module.exports = __webpack_public_path__ + "static/media/MI-logo-final_White.45a1e2b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/MI-logo-final_White.png
// module id = 1484
// module chunks = 0